function getConditionChildrenKey(conditionId: string, optionId: string) {
  return `${conditionId}-${optionId}`;
}

export default getConditionChildrenKey;
